<template>
  <div class="track-and-trace-content-wrapper">
    <div class="track-and-trace-content" :key="'job_' + index"
         v-for="(jobSet, index) in (orderStatus ? orderStatus : 1)">
      <div class="row m-0 track-and-trace-custom-properties" v-if="!editing">

        <template v-for="n in 3">
          <div v-if="getResolvedRouteExtras['customPropertyKey' + (n - 1)]" :key="'main-property-' + n"
               class="col-12 custom-property-column"
               :class="'col-md-' + getAmountOfColumns">
            <div class="suborder-label">{{ getResolvedRouteExtras['customPropertyLabel' + (n - 1)] }}</div>
            <div class="suborder-value">
              {{ getPropertyValue(jobSet, getResolvedRouteExtras['customPropertyKey' + (n - 1)]) }}
            </div>
          </div>
        </template>
      </div>
      <hr v-if="!editing">

      <div class="row" v-if="exception">
        <div class="col-12">
          <div class="alert alert-info" role="alert">
            <span style="white-space: pre-wrap">
              {{ getExceptionDisplayMessage }}
            </span>

            <!--        <p class="mb-0">Additional footer text or actions can go here.</p>-->

            <!--          {{exception.message}}-->
          </div>
        </div>
      </div>


      <div v-if="editing">


        <ul class="nav nav-tabs" id="myTab" role="tablist">
          <li class="nav-item" role="presentation">
            <button class="nav-link active" id="main-tab" data-toggle="tab" data-target="#main" type="button" role="tab"
                    aria-controls="main" aria-selected="true">Main routing
            </button>
          </li>

          <li class="nav-item" role="presentation" v-for="(customRoute, index) in getCustomRouteToShow" :key="index">
            <button class="nav-link"
                    :id="'customRoute-tab-' + index"
                    data-toggle="tab"
                    :data-target="'#customRoute-' + index"
                    type="button"
                    role="tab"
                    :aria-controls="'customRoute-' + index"
                    aria-selected="false">
              {{ customRoute.name ? customRoute.name : index }} <i style="line-height:1.5;color:#C23E3E;cursor: pointer"
                                                                   class="fa fa-trash ml-3 float-right"
                                                                   @click="deleteCustomRoute(index)"> </i>
            </button>
          </li>

          <li class="nav-item" role="presentation">
            <button class="nav-link text-right" id="addRoute-tab"
                    aria-controls="addRoute" aria-selected="false" @click="addCustomRoute()">
              Add custom route <i class="fas fa-plus"></i>
            </button>
          </li>
        </ul>
        <div class="tab-content" id="myTabContent">
          <div class="tab-pane fade show active" id="main" role="tabpanel" aria-labelledby="main-tab">

            <div class="col-12 mb-5 route-general-settings">
              <h5 class="mb-0">General settings</h5>
              <TrackAndTraceHeader :editing="editing" ref="trackAndTraceHeaderMain"/>
              <TrackAndTraceBanner :editing="editing" ref="trackAndTraceBannerMain"/>
              <TrackAndTraceInformation :editing="editing" ref="trackAndTraceInformationMain"/>
            </div>

            <div class="col-12 mb-5 custom-properties-editor">
              <div class="row m-0">
                <div class="col-12 col-md-4 custom-property-column">
                  <label for="customPropertyKey0">{{ $t('trackAndTrace.content.customPropertyKey') }}</label>
                  <select class="form-control" v-model="customPropertyKey0" id="customPropertyKey0">
                    <option :value="null">{{ $t('trackAndTrace.content.dontDisplayProperty') }}</option>
                    <option v-for="key in getPossibleProductKeys" :value="key" :key="key">{{
                        translateCustomProperty(key)
                      }}
                    </option>
                  </select>
                  <label for="customPropertyLabel0">{{ $t('trackAndTrace.content.customPropertyLabel') }}</label>
                  <input type="text" id="customPropertyLabel0" class="form-control" v-model="customPropertyLabel0">
                </div>
                <div class="col-12 col-md-4 custom-property-column">
                  <label for="customPropertyKey1">{{ $t('trackAndTrace.content.customPropertyKey') }}</label>
                  <select class="form-control" v-model="customPropertyKey1" id="customPropertyKey1">
                    <option :value="null">{{ $t('trackAndTrace.content.dontDisplayProperty') }}</option>
                    <option v-for="key in getPossibleProductKeys" :value="key" :key="key">{{
                        translateCustomProperty(key)
                      }}
                    </option>
                  </select>
                  <label for="customPropertyLabel1">{{ $t('trackAndTrace.content.customPropertyLabel') }}</label>
                  <input type="text" id="customPropertyLabel1" class="form-control" v-model="customPropertyLabel1">
                </div>
                <div class="col-12 col-md-4 custom-property-column">
                  <label for="customPropertyKey2">{{ $t('trackAndTrace.content.customPropertyKey') }}</label>
                  <select class="form-control" v-model="customPropertyKey2" id="customPropertyKey2">
                    <option :value="null">{{ $t('trackAndTrace.content.dontDisplayProperty') }}</option>
                    <option v-for="key in getPossibleProductKeys" :value="key" :key="key">{{
                        translateCustomProperty(key)
                      }}
                    </option>
                  </select>
                  <label for="customPropertyLabel2">{{ $t('trackAndTrace.content.customPropertyLabel') }}</label>
                  <input type="text" id="customPropertyLabel2" class="form-control" v-model="customPropertyLabel2">
                </div>
              </div>
            </div>

            <TrackAndTraceColumns @columnChanged="handleColumnChange($event)"
                                  @extraDurationChanged="setExtraDuration($event)"
                                  :customRoute="getCustomRouteToShow"
                                  :jobs="jobSet" ref="trackAndTraceColumns"
                                  :editing="editing"/>

            <div class="col-12 mb-5 exceptions-editor">
              <div class="row ml-0 mr-0 mt-3 align-items-center">
                <div class="col d-flex align-items-center">
                  <h5 class="mb-0">{{ $t('trackAndTrace.content.exceptionsTitle') }}</h5>
                  <small class="exception-date-info ml-3 mb-0">{{
                      $t('trackAndTrace.content.exceptionDateInfoBefore')
                    }}<code>{date}</code>{{ $t('trackAndTrace.content.exceptionDateInfoAfter') }}</small>
                </div>
                <button class="add-exception-button motivate-primary-button-outline ml-auto mr-3" @click="addException">{{
                    $t('trackAndTrace.content.addException')
                  }}
                </button>
              </div>

              <div class="exceptions-list">
                <div v-if="!exceptions.length" class="text-muted-label">{{ $t('trackAndTrace.content.noExceptions') }}</div>

                <div class="exception-card" v-for="(exception, index) in exceptions" :key="'ex-' + index">
                  <div class="exception-card-header">
                    <span class="exception-card-title">{{ $t('trackAndTrace.content.exceptionsTitle') }} #{{ index + 1 }}</span>
                    <i class="fa fa-trash exception-delete-icon" :title="$t('ui.delete')" @click="removeException(index)"></i>
                  </div>
                  <div class="exception-card-row">
                    <div class="exception-card-field">
                      <label>{{ $t('trackAndTrace.content.exceptionType') }}
                        <i v-if="jobsLoading" class="fad fa-spinner fa-spin ml-1"
                           style="--fa-primary-color: #2A52BE; --fa-secondary-color: #1CB1AD;"></i>
                      </label>
                      <select class="form-control" v-model="exception.key">
                        <option v-for="key in getUniqueJobKeys" :value="key" :key="key">{{ key }}</option>
                      </select>
                    </div>
                    <div class="exception-card-field">
                      <label>{{ $t('trackAndTrace.content.showDate') }}</label>
                      <select class="form-control" v-model="exception.dateKey">
                        <option :value="null">{{ $t('trackAndTrace.content.selectDateField') }}</option>
                        <option v-for="key in getUniqueDateJobKeys" :value="key" :key="key">{{ key }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="exception-card-field exception-card-field-full">
                    <label>{{ $t('trackAndTrace.content.exceptionMessage') }}</label>
                    <textarea class="form-control" rows="2" v-model="exception.message"></textarea>
                  </div>
                  <div class="exception-card-field exception-card-field-full">
                    <div class="text-muted-label">{{ $t('trackAndTrace.content.exceptionPreview') }}</div>
                    <div class="alert alert-info" role="alert">
                      <span style="white-space: pre-wrap">{{ getExceptionPreviewMessage(exception) }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="route-actions-row">
              <button class="route-back-button motivate-primary-button-outline" @click="$emit('back')">{{ $t('ui.back') }}</button>
              <button class="route-save-button motivate-primary-button" @click="saveRouteSettings()">{{ $t('trackAndTrace.content.saveRoute') }}</button>
            </div>
          </div>

          <div class="tab-pane fade"
               v-for="(customRoute, index) in getCustomRouteToShow"
               :id="'customRoute-' + index"
               role="tabpanel"
               :aria-labelledby="'customRoute-tab-' + index"
               :key="'pane-' + index">
            <div class="tab-pane fade show active" :id="'customRoute-' + index" role="tabpanel"
                 aria-labelledby="main-tab">


              <div class="col-12 mb-5 route-general-settings">
                <h5 class="mb-0">Route-specific general settings</h5>
                <small class="text-muted-label">Leave a field empty to keep using the main setting for this route.</small>

                <label :for="'route-skus-' + index">Linked on SKU</label>
                <tags-input :id="'route-skus-' + index"
                            v-model="customRoute.linkedTo.values"
                            :existing-tags="getUniqueTags"
                            :value-fields="'value'"
                            :typeahead="true"
                            :typeahead-activation-threshold="threshold"
                            :typeahead-always-show="false"
                            @focus="threshold = 0"
                            :typeahead-max-results="10000"
                            @blur="threshold = 1;"
                            :typeahead-hide-discard="true"
                            :typeahead-style="'dropdown'"
                            :limit="0"
                            :typeahead-filter="customTypeaheadFilter"
                            :sort-search-results="false"
                            :add-tags-on-blur="false"
                            :hide-input-on-limit="true"
                ></tags-input>

                <TrackAndTraceHeader :editing="editing" :customRoute="customRoute" ref="trackAndTraceHeaderCustom"/>
                <TrackAndTraceBanner :editing="editing" :customRoute="customRoute" ref="trackAndTraceBannerCustom"/>
                <TrackAndTraceInformation :editing="editing" :customRoute="customRoute" ref="trackAndTraceInformationCustom"/>
              </div>

              <div class="col-12 mb-5 custom-properties-editor">
                <div class="row m-0">
                  <div class="col-12 col-md-4 custom-property-column">
                    <label :for="'customPropertyKey0-' + index">{{ $t('trackAndTrace.content.customPropertyKey') }}</label>
                    <select class="form-control" v-model="customRoute.customPropertyKey0" :id="'customPropertyKey0-' + index">
                      <option :value="null">{{ $t('trackAndTrace.content.dontDisplayProperty') }}</option>
                      <option v-for="key in getPossibleProductKeys" :value="key" :key="key">{{
                          translateCustomProperty(key)
                        }}
                      </option>
                    </select>
                    <label :for="'customPropertyLabel0-' + index">{{ $t('trackAndTrace.content.customPropertyLabel') }}</label>
                    <input type="text" :id="'customPropertyLabel0-' + index" class="form-control" v-model="customRoute.customPropertyLabel0">
                  </div>
                  <div class="col-12 col-md-4 custom-property-column">
                    <label :for="'customPropertyKey1-' + index">{{ $t('trackAndTrace.content.customPropertyKey') }}</label>
                    <select class="form-control" v-model="customRoute.customPropertyKey1" :id="'customPropertyKey1-' + index">
                      <option :value="null">{{ $t('trackAndTrace.content.dontDisplayProperty') }}</option>
                      <option v-for="key in getPossibleProductKeys" :value="key" :key="key">{{
                          translateCustomProperty(key)
                        }}
                      </option>
                    </select>
                    <label :for="'customPropertyLabel1-' + index">{{ $t('trackAndTrace.content.customPropertyLabel') }}</label>
                    <input type="text" :id="'customPropertyLabel1-' + index" class="form-control" v-model="customRoute.customPropertyLabel1">
                  </div>
                  <div class="col-12 col-md-4 custom-property-column">
                    <label :for="'customPropertyKey2-' + index">{{ $t('trackAndTrace.content.customPropertyKey') }}</label>
                    <select class="form-control" v-model="customRoute.customPropertyKey2" :id="'customPropertyKey2-' + index">
                      <option :value="null">{{ $t('trackAndTrace.content.dontDisplayProperty') }}</option>
                      <option v-for="key in getPossibleProductKeys" :value="key" :key="key">{{
                          translateCustomProperty(key)
                        }}
                      </option>
                    </select>
                    <label :for="'customPropertyLabel2-' + index">{{ $t('trackAndTrace.content.customPropertyLabel') }}</label>
                    <input type="text" :id="'customPropertyLabel2-' + index" class="form-control" v-model="customRoute.customPropertyLabel2">
                  </div>
                </div>
              </div>

              <TrackAndTraceColumnsCustom

                  @columnChanged="handleCustomColumnChange($event,index)"
                  @extraDurationChanged="setExtraDurationCustom($event,index)"
                  @nameChanged="setNameChange($event,index)"
                  :customRoute="customRoute"
                  :jobs="jobSet"
                  ref="trackAndTraceColumnsCustom"
                  :editing="editing"/>

              <div class="col-12 mb-5 exceptions-editor">
                <div class="row ml-0 mr-0 mt-3 align-items-center">
                  <div class="col d-flex align-items-center">
                    <h5 class="mb-0">{{ $t('trackAndTrace.content.exceptionsTitle') }}</h5>
                    <small class="exception-date-info ml-3 mb-0">{{
                        $t('trackAndTrace.content.exceptionDateInfoBefore')
                      }}<code>{date}</code>{{ $t('trackAndTrace.content.exceptionDateInfoAfter') }}</small>
                  </div>
                  <button class="add-exception-button motivate-primary-button-outline ml-auto mr-3" @click="addExceptionToRoute(customRoute)">{{
                      $t('trackAndTrace.content.addException')
                    }}
                  </button>
                </div>

                <div class="exceptions-list">
                  <div v-if="!customRoute.exceptions || !customRoute.exceptions.length" class="text-muted-label">{{ $t('trackAndTrace.content.noExceptions') }}</div>

                  <div class="exception-card" v-for="(exception, exIndex) in customRoute.exceptions" :key="'route-' + index + '-ex-' + exIndex">
                    <div class="exception-card-header">
                      <span class="exception-card-title">{{ $t('trackAndTrace.content.exceptionsTitle') }} #{{ exIndex + 1 }}</span>
                      <i class="fa fa-trash exception-delete-icon" :title="$t('ui.delete')" @click="removeExceptionFromRoute(customRoute, exIndex)"></i>
                    </div>
                    <div class="exception-card-row">
                      <div class="exception-card-field">
                        <label>{{ $t('trackAndTrace.content.exceptionType') }}
                          <i v-if="jobsLoading" class="fad fa-spinner fa-spin ml-1"
                             style="--fa-primary-color: #2A52BE; --fa-secondary-color: #1CB1AD;"></i>
                        </label>
                        <select class="form-control" v-model="exception.key">
                          <option v-for="key in getUniqueJobKeys" :value="key" :key="key">{{ key }}</option>
                        </select>
                      </div>
                      <div class="exception-card-field">
                        <label>{{ $t('trackAndTrace.content.showDate') }}</label>
                        <select class="form-control" v-model="exception.dateKey">
                          <option :value="null">{{ $t('trackAndTrace.content.selectDateField') }}</option>
                          <option v-for="key in getUniqueDateJobKeys" :value="key" :key="key">{{ key }}</option>
                        </select>
                      </div>
                    </div>
                    <div class="exception-card-field exception-card-field-full">
                      <label>{{ $t('trackAndTrace.content.exceptionMessage') }}</label>
                      <textarea class="form-control" rows="2" v-model="exception.message"></textarea>
                    </div>
                    <div class="exception-card-field exception-card-field-full">
                      <div class="text-muted-label">{{ $t('trackAndTrace.content.exceptionPreview') }}</div>
                      <div class="alert alert-info" role="alert">
                        <span style="white-space: pre-wrap">{{ getExceptionPreviewMessage(exception) }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="route-actions-row">
                <button class="route-back-button motivate-primary-button-outline" @click="$emit('back')">{{ $t('ui.back') }}</button>
                <button class="route-save-button motivate-primary-button" @click="saveRouteSettings(customRoute)">{{ $t('trackAndTrace.content.saveRoute') }}</button>
              </div>

            </div>

            <div class="tab-pane fade" id="addRoute" role="tabpanel" aria-labelledby="addRoute-tab">Add custom route
            </div>
          </div>

        </div>

      </div>
      <div v-if="!editing && !exception">

        <TrackAndTraceColumns @columnChanged="handleColumnChange($event)"
                              @extraDurationChanged="setExtraDuration($event)"
                              :customRoute="getCustomRouteToShow"
                              :jobs="jobSet" ref="trackAndTraceColumns"
                              :editing="editing"
                              :orderStatus="orderStatus"/>
      </div>
    </div>

  </div>
</template>

<script>
import {mapGetters} from "vuex";
import TrackAndTraceColumns from "@/components/trackAndTrace/TrackAndTraceColumns.vue";
import TrackAndTraceColumnsCustom from "./TrackAndTraceColumnsCustom.vue";
import TrackAndTraceHeader from "./TrackAndTraceHeader.vue";
import TrackAndTraceBanner from "./TrackAndTraceBanner.vue";
import TrackAndTraceInformation from "./TrackAndTraceInformation.vue";
import {resolveRouteFields, buildRouteSettingsFrom, matchRouteForOrder} from "@/utils/trackAndTraceRoute";

export default {
  name: "TrackAndTraceContent",
  components: {TrackAndTraceColumns, TrackAndTraceColumnsCustom, TrackAndTraceHeader, TrackAndTraceBanner, TrackAndTraceInformation},
  props: ['editing', 'orderStatus'],
  data() {
    return {
      exception: null,
      exceptionJob: null,
      exceptions: [],
      customPropertyLabel0: null,
      customPropertyLabel1: null,
      customPropertyLabel2: null,
      customPropertyKey0: null,
      customPropertyKey1: null,
      customPropertyKey2: null,
      activitiesColumn0: {label: null, activities: []},
      activitiesColumn1: {label: null, activities: []},
      activitiesColumn2: {label: null, activities: []},
      activitiesColumn3: {label: null, activities: []},
      extraDuration: 0,
      threshold: 1,
      jobsLoading: false,
      jobSamples: []
    }
  },
  computed: {
    ...mapGetters('trackAndTrace', ['getTrackAndTraceConfig']),
    ...mapGetters('company', ['getConfig']),
    ...mapGetters("users", ["getClaims", "getMe"]),
    ...mapGetters('products', ['getProducts']),
    getUniqueTags() {
      const uniqValues = _.uniq(this.getProducts.map(p => p.productNumber));
      return _.map(uniqValues, value => {
        return {
          key: _.kebabCase(value.toString()),
          value: value.toString()
        }
      })
    },
    getCustomRoutes() {
      return this.getTrackAndTraceConfig.customRoutes;
    },
    getCustomRouteToShow() {
      if (this.editing) {
        return this.getTrackAndTraceConfig.customRoutes
      }
      let customRoutes = this.getTrackAndTraceConfig.customRoutes
      if (!customRoutes) {
        return null
      } else {
        return matchRouteForOrder(this.orderStatus, customRoutes)
      }
    },
    getResolvedRouteExtras() {
      const main = this.getTrackAndTraceConfig;
      const matched = this.getCustomRouteToShow;
      const resolved = resolveRouteFields(main, matched);
      // Exceptions are owned entirely by whichever route is active - a matched route's own
      // list is authoritative even if it's empty (meaning "this route has no exceptions").
      // Main's exceptions only apply when no custom route matched at all.
      resolved.exceptions = matched ? (matched.exceptions || []) : main.exceptions;
      return resolved;
    },
    getUniqueProductNumbers() {
      let key = this.getTrackAndTraceConfig.customFilterKey ? this.getTrackAndTraceConfig.customFilterKey : 'skus';
      return _.uniq(
          this.jobSamples
              .map(job => job[key])  // Replace 'productNumber' with the actual key you're looking for
              .filter(value => value != null)    // Filter out any null or undefined values
      );
    },
    getUniqueJobKeys() {
      const uniqueKeys = _.uniq(_.flattenDeep(_.map(this.jobSamples, job => {
        // if(job.orderNumber === "100002523" ){
        //   console.log(job)
        // }
        return _.keys(job);
      })));

      return uniqueKeys.filter(key => {

        // Check if at least one job has a boolean value for this key
        return this.jobSamples.some(job => typeof job[key] === 'boolean');
      }).filter(key => !['created_at', 'created_by', 'updated_at', 'updated_by', 'id', 'companyId', 'productionStart', 'productionEnd'].includes(key)).sort();
    },
    getUniqueDateJobKeys() {
      const uniqueKeys = _.uniq(_.flattenDeep(_.map(this.jobSamples, job => {
        return _.keys(job);
      })));

      return uniqueKeys.filter(key => {
        // Check if at least one job has a date-like value for this key
        return this.jobSamples.some(job => this.isDateLikeValue(job[key]));
      }).filter(key => !['created_at', 'created_by', 'updated_at', 'updated_by', 'id', 'companyId'].includes(key)).sort();
    },
    getPossibleProductKeys() {
      const dynamicOptions = ['DYNAMIC_TIME_LEFT'];


      if (this.getConfig && this.getConfig.trackAndTrace && this.getConfig.trackAndTrace.customProperties) {
        return _.concat(this.getConfig.trackAndTrace.customProperties, dynamicOptions)
      } else {
        const uniqueKeys = _.uniq(_.flattenDeep(_.map(this.jobSamples, job => {
          return _.keys(job)
        })));
        return _.concat(_.filter(uniqueKeys, key => ['created_at', 'created_by', 'updated_at', 'updated_by', 'id', 'companyId'].indexOf(key) === -1), dynamicOptions)
      }
    },
    getAmountOfColumns() {
      if (this.editing) {
        return 4;
      }
      const extras = this.getResolvedRouteExtras;
      const amountOfEnabledKeys = _.filter([!!extras.customPropertyKey0, !!extras.customPropertyKey1, !!extras.customPropertyKey2], key => {
        return !!key
      }).length;
      return 12 / amountOfEnabledKeys;
    },
    getExceptionDisplayMessage() {
      if (!this.exception) {
        return '';
      }
      const message = this.exception.message || '';
      let dateValue = '';
      if (this.exception.dateKey) {
        // The date field isn't necessarily on the job that triggered the exception -
        // it can live on any job in the order's chain, so search all of them.
        const flattenedJobs = _.flattenDeep(this.orderStatus);
        const jobWithDate = flattenedJobs.find(job => this.isDateLikeValue(job[this.exception.dateKey]));
        if (jobWithDate) {
          dateValue = this.formatDateValue(jobWithDate[this.exception.dateKey]) || '';
        }
      }
      return message.split('{date}').join(dateValue);
    },

  },
  methods: {
    async addCustomRoute() {
      if (!this.getTrackAndTraceConfig.customRoutes) {
        this.$set(this.getTrackAndTraceConfig, 'customRoutes', []);
      }
      const existingRoutes = this.getTrackAndTraceConfig.customRoutes;

      const inputOptions = {blank: 'Blank route', default: 'Use default (main) values'};
      existingRoutes.forEach((route, index) => {
        inputOptions['route:' + index] = 'Copy from "' + (route.name ? route.name : index) + '"';
      });

      const result = await this.$swal({
        title: 'Add custom route',
        text: 'Choose a starting point for this route\'s settings',
        input: 'select',
        inputOptions,
        inputPlaceholder: 'Select a starting point',
        showCancelButton: true,
        confirmButtonText: 'Add',
        confirmButtonColor: '#2A52BE', // $ceruleanBlue
        cancelButtonText: this.$root.$t('ui.cancel'),
        reverseButtons: true
      });

      if (!result.value) {
        return;
      }

      let source = null;
      if (result.value === 'default') {
        source = this.getTrackAndTraceConfig;
      } else if (result.value.startsWith('route:')) {
        const sourceIndex = parseInt(result.value.split(':')[1], 10);
        source = existingRoutes[sourceIndex];
      }

      existingRoutes.push(Object.assign(buildRouteSettingsFrom(source), {
        name: "new route",
        linkedTo: {
          key: "skus",
          values: []
        }
      }));

    },
    async deleteCustomRoute(index) {

      let result = await this.$swal({
        title: 'Are you sure?',
        html: 'Deleting will remove the custom route',
        icon: 'error',
        customClass: 'm-swal-delete',
        confirmButtonText: this.$root.$t('ui.delete'),
        showCancelButton: true,
        cancelButtonText: this.$root.$t('ui.cancel'),
        reverseButtons: true
      })
      if (result.value){
        $('#customRoute-tab-' +   (index-1)).tab('show')

        this.getTrackAndTraceConfig.customRoutes.splice(index, 1)

        //
      }
    },

    addException() {
      this.exceptions.push({
        key: null,
        message: "",
        dateKey: null

      })
    }
    ,
    removeException(index) {
      this.exceptions.splice(index, 1)
    }
    ,
    addExceptionToRoute(customRoute) {
      if (!customRoute.exceptions) {
        this.$set(customRoute, 'exceptions', []);
      }
      customRoute.exceptions.push({
        key: null,
        message: "",
        dateKey: null
      })
    }
    ,
    getExceptionPreviewMessage(exception) {
      const message = exception.message || '';
      const dateValue = exception.dateKey ? moment().format('DD-MM-YYYY') : '';
      return message.split('{date}').join(dateValue);
    }
    ,
    removeExceptionFromRoute(customRoute, index) {
      customRoute.exceptions.splice(index, 1)
    }
    ,
    async saveRouteSettings(customRoute) {
      try {
        if (!customRoute) {
          // The main tab's general settings (header/banner/information) live in refs here
          // rather than on getTrackAndTraceConfig directly, so gather them up before patching -
          // this used to only happen via the top-level Save button in EditTrackAndTrace.vue,
          // but each route's own "Save route" button now needs to persist everything itself.
          const headerRef = this.$refs.trackAndTraceHeaderMain[0];
          const bannerRef = this.$refs.trackAndTraceBannerMain[0];
          const informationRef = this.$refs.trackAndTraceInformationMain[0];

          const patch = {
            id: this.getTrackAndTraceConfig.id,
            customPropertyKey0: this.customPropertyKey0,
            customPropertyLabel0: this.customPropertyLabel0,
            customPropertyKey1: this.customPropertyKey1,
            customPropertyLabel1: this.customPropertyLabel1,
            customPropertyKey2: this.customPropertyKey2,
            customPropertyLabel2: this.customPropertyLabel2,
            exceptions: this.exceptions,
            secretKeyLabel: headerRef.secretKeyLabel,
            bannerText: bannerRef.bannerText,
            orderNotFoundText: bannerRef.orderNotFoundText,
            orderNumberKey: informationRef.orderNumberKey,
            orderNumberLabel: informationRef.orderNumberLabel,
            informationLink: informationRef.informationLink,
            informationText: informationRef.informationText,
            activitiesColumn0: this.activitiesColumn0,
            activitiesColumn1: this.activitiesColumn1,
            activitiesColumn2: this.activitiesColumn2,
            activitiesColumn3: this.activitiesColumn3,
            extraDuration: parseInt(this.extraDuration)
          };

          const headerUpload = await headerRef.$refs.dragAndDropContainer.uploadFiles(false, this.getTrackAndTraceConfig.id);
          if (headerUpload && headerUpload.length) {
            patch.logoFileName = _.first(headerUpload).metadata.name;
          }

          const bannerUpload = await bannerRef.$refs.dragAndDropContainer.uploadFiles(false, this.getTrackAndTraceConfig.id);
          if (bannerUpload && bannerUpload.length) {
            patch.bannerFileName = _.first(bannerUpload).metadata.name;
          }

          await this.$store.dispatch('trackAndTrace/patch', patch);
        } else {
          // The route's text fields (secretKeyLabel, bannerText, orderNotFoundText, orderNumberKey,
          // informationLink, informationText) are already written straight onto `customRoute` via
          // v-model as the user types - only the pending file uploads still need to happen here.
          const routeIndex = this.getTrackAndTraceConfig.customRoutes.indexOf(customRoute);
          const headerRef = this.$refs.trackAndTraceHeaderCustom[routeIndex];
          const bannerRef = this.$refs.trackAndTraceBannerCustom[routeIndex];

          const headerUpload = await headerRef.$refs.dragAndDropContainer.uploadFiles(false);
          if (headerUpload && headerUpload.length) {
            this.$set(customRoute, 'logoFileName', _.first(headerUpload).metadata.name);
          }

          const bannerUpload = await bannerRef.$refs.dragAndDropContainer.uploadFiles(false);
          if (bannerUpload && bannerUpload.length) {
            this.$set(customRoute, 'bannerFileName', _.first(bannerUpload).metadata.name);
          }

          await this.$store.dispatch('trackAndTrace/patch', {
            id: this.getTrackAndTraceConfig.id,
            customRoutes: this.getTrackAndTraceConfig.customRoutes
          })
        }
        this.$toasted.global.successRequest({message: this.$t('ui.saved')});
      } catch (e) {
        this.$toasted.global.failedFormRequest();
        console.error(e);
      }
    }
    ,
    async fetchJobSamples() {
      // A plain one-off read instead of jobs/fetchAndAdd: it skips vuex-easy-firestore's
      // timestamp conversion/merge per doc and doesn't grow the shared jobs Vuex module -
      // this is only used to sample which fields/types occur, not to display real job data.
      // Freezing each doc keeps Vue from setting up reactivity on every one of its fields.
      const snapshot = await this.$FB.collection('jobs')
          .where('companyId', '==', this.getClaims.companyId)
          .where('plannedDate', '>=', moment().subtract(60, 'day').toDate())
          .limit(300)
          .get();
      this.jobSamples = snapshot.docs.map(doc => Object.freeze(doc.data()));
    }
    ,
    translateCustomProperty(value) {
      if (!value) return ''
      else if (value === 'DYNAMIC_TIME_LEFT') {
        return this.$t('trackAndTrace.content.dynamicProperties.timeLeft');
      } else {
        return value;
      }
    }
    ,
    customTypeaheadFilter(tag, query) {
      return tag.value.toLowerCase().includes(query.toLowerCase()); // Match value partially
    }
    ,
    setExtraDuration(newDuration) {
      this.extraDuration = newDuration;
    }
    ,
    setExtraDurationCustom(newDuration, index) {
      this.getTrackAndTraceConfig.customRoutes[index][`extraDuration`] = newDuration;

    },
    setNameChange(nameChange, index) {
      this.getTrackAndTraceConfig.customRoutes[index][`name`] = nameChange;
    },
    handleColumnChange(columnChange) {
      this[`activitiesColumn${columnChange.columnIndex}`] = columnChange.data;
    }
    ,
    handleCustomColumnChange(columnChange, index) {
      this.getTrackAndTraceConfig.customRoutes[index].columns[`activitiesColumn${columnChange.columnIndex}`] = columnChange.data;
    }
    ,
    getPropertyValue(jobSet, property) {
      if (property === 'DYNAMIC_TIME_LEFT') {
        let daysLeft = _.sumBy(jobSet, job => {
          if (job.status === 'finished') {
            return 0;
          } else {
            let amountOfDaysLeft = 1;
            for (let i = 0; i < 4; i++) {
              const matchingroutes = this.getCustomRouteToShow ? this.getCustomRouteToShow  : this.getTrackAndTraceConfig;

              const activitySettings = _.find(matchingroutes[`activitiesColumn${i}`].activities, {'value': job.activity});
              if (activitySettings) {
                if (activitySettings.workingDays !== null) {
                  amountOfDaysLeft = parseInt(activitySettings.workingDays);
                }
              }
            }
            return amountOfDaysLeft;
          }
        });
        if (daysLeft && this.getResolvedRouteExtras.extraDuration) {
          // Add extra duration when there are still days left
          daysLeft += parseInt(this.getResolvedRouteExtras.extraDuration);
        }
        return this.$tc('trackAndTrace.content.days', daysLeft);
      } else {
        return jobSet && jobSet[0] ? jobSet[0][property] : '';
      }
    }
    ,
    getFirstMatchingException(orderStatus, exceptions) {
      // Flatten the jobs array if it's an array of arrays
      const flattenedJobs = _.flattenDeep(orderStatus);

      for (const exception of exceptions) {
        const matchingJob = flattenedJobs.find(job => job[exception.key] === true);
        if (matchingJob) {
          return {exception, job: matchingJob};
        }
      }
      return null; // Return null if no match is found
    }
    ,
    isPlainTimestampObject(value) {
      // Cloud Functions responses that go through JSON.stringify/JSON.parse turn a
      // Firestore Timestamp into a plain {_seconds, _nanoseconds} object (no toDate()).
      if (!value || typeof value !== 'object') {
        return false;
      }
      const seconds = value._seconds !== undefined ? value._seconds : value.seconds;
      return typeof seconds === 'number';
    }
    ,
    isDateLikeValue(value) {
      if (value === null || value === undefined) {
        return false;
      }
      if (typeof value.toDate === 'function') {
        return true; // Firestore Timestamp (client SDK)
      }
      if (value instanceof Date) {
        return true;
      }
      if (this.isPlainTimestampObject(value)) {
        return true; // Firestore Timestamp after JSON serialization
      }
      if (typeof value === 'string') {
        // Not every date field on a job is a Firestore Timestamp - some come in as
        // plain strings in whichever format the source system used, so check common
        // ones instead of only strict ISO 8601.
        return moment(value, ['YYYY-MM-DD', 'DD-MM-YYYY', 'DD-MM-YY', moment.ISO_8601], true).isValid();
      }
      return false;
    }
    ,
    toMomentDate(value) {
      if (!this.isDateLikeValue(value)) {
        return null;
      }
      if (typeof value.toDate === 'function') {
        return moment(value.toDate());
      }
      if (this.isPlainTimestampObject(value)) {
        const seconds = value._seconds !== undefined ? value._seconds : value.seconds;
        const nanoseconds = value._nanoseconds !== undefined ? value._nanoseconds : (value.nanoseconds || 0);
        return moment(seconds * 1000 + Math.floor(nanoseconds / 1e6));
      }
      return moment(value);
    }
    ,
    formatDateValue(value) {
      const momentDate = this.toMomentDate(value);
      return momentDate ? momentDate.format('DD-MM-YYYY') : '';
    }
  },
  created() {
    this.customPropertyLabel0 = this.getTrackAndTraceConfig.customPropertyLabel0;
    this.customPropertyKey0 = this.getTrackAndTraceConfig.customPropertyKey0;
    this.customPropertyLabel1 = this.getTrackAndTraceConfig.customPropertyLabel1;
    this.customPropertyKey1 = this.getTrackAndTraceConfig.customPropertyKey1;
    this.customPropertyLabel2 = this.getTrackAndTraceConfig.customPropertyLabel2;
    this.customPropertyKey2 = this.getTrackAndTraceConfig.customPropertyKey2;
    this.extraDuration = this.getTrackAndTraceConfig.extraDuration ? this.getTrackAndTraceConfig.extraDuration : 0;
    this.exceptions = this.getTrackAndTraceConfig.exceptions ? this.getTrackAndTraceConfig.exceptions : []
    if (this.editing) {

      this.jobsLoading = true;
      this.fetchJobSamples().finally(() => {
        this.jobsLoading = false;
      });
      this.$store.dispatch('products/fetchAndAdd', {limit:0,where:[ ['companyId', '==', this.getClaims.companyId]]})
    } else {
      if (this.getResolvedRouteExtras.exceptions) {
        let match = this.getFirstMatchingException(this.orderStatus, this.getResolvedRouteExtras.exceptions)
        if (match) {
          this.exception = match.exception
          this.exceptionJob = match.job
        }
        // check every key in exceptions to the job and if true on the  first hit then trigger an alert

      }
    }
  }
  ,
  watch: {}
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/MotivateColors";

$informationHeight: 68px;

.nav-tabs .nav-link {
  color: $besWelBlack;
}

.nav-tabs .nav-link.active,
.nav-tabs .nav-link:hover {
  color: $ceruleanBlue;
  border-color: $grey $grey $walterWhite;
}

.nav-tabs .nav-link.active {
  border-bottom: 2px solid $ceruleanBlue;
}

@media only screen and (max-width: 900px) {
  .track-and-trace-content {
    margin-left: 8px !important;
    margin-right: 8px !important;
    padding: 8px 8px !important;
  }
}

.track-and-trace-content {
  margin-left: 48px;
  margin-right: 48px;
  padding: 12px 32px;

  background: $walterWhite;
  border: 1px solid $grey;
  border-radius: 8px;
}

.track-and-trace-content:not(:last-child) {
  margin-bottom: 34px;
}


.custom-property-column {
  text-align: center;

}

.custom-property-column:first-child {
  text-align: left !important;
}

.custom-property-column:last-child {
  text-align: right;
}


// To align all text again on small displays 768px = bootstrap md. And on col-md-12 all should be left
@media (max-width: 768px) {
  .custom-property-column {
    text-align: left !important;
  }
}

.suborder-label {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 140%;
  letter-spacing: 0.25px;
  color: $besWelBlack;
}

.suborder-value {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 0.875rem;
  line-height: 140%;
  letter-spacing: 0.25px;
  color: $besWelBlack;
}

#customPropertyKey0, #customPropertyKey1, #customPropertyKey2 {
  margin-bottom: 12px;
}

.alert {
  &.alert-info {
    background: $ceruleanBlue !important;
  }

  border-radius: 5px;
}

.route-actions-row {
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
}

.route-back-button,
.route-save-button {
  flex: 1;
}

.add-exception-button {
  width: auto;
  flex: 0 0 auto;
  padding: 10px 24px;
  font-size: 1.05rem;
}

.exception-date-info {
  color: #000;
}

.text-muted-label {
  color: $besWelBlack;
  margin-bottom: 4px;
}

.exceptions-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 12px;
}

.exception-card {
  border: 1px solid $grey;
  border-radius: 8px;
  padding: 16px;
  background: $walterWhite;
}

.exception-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.exception-card-title {
  font-weight: 600;
  color: $besWelBlack;
}

.exception-card-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 12px;
}

.exception-card-field label {
  display: block;
  margin-bottom: 4px;
  color: $besWelBlack;
}

.exception-card-field-full {
  margin-bottom: 12px;
}

.exception-card-field-full:last-child {
  margin-bottom: 0;
}

@media (max-width: 600px) {
  .exception-card-row {
    grid-template-columns: 1fr;
  }
}

.exception-delete-icon {
  color: #C23E3E;
  cursor: pointer;
  line-height: 1.5;
}
</style>